import React, { useState, useContext, useEffect, useCallback } from 'react';
import P from 'prop-types';
import { toast } from 'react-toastify';
import { Button } from '../Button';
import { Modal } from '../Modal';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../contexts/HomeContext';
import {
  ClearPedido,
  FormataValor,
  GetListPedidosEnvio,
  GetStatusLoja,
  GetUsuario,
  isObjectEmpty,
} from '../../utils/utils';
import { useSocketio } from '../../contexts/SocketioContext';

// import $ from 'jquery';
// window.jQuery = $;
// require('signalr');

export const SacolaRodape = ({ param }) => {
  const { dadosApp, setSacola, user, sacola, statusLoja, setStatusLoja } = useContext(GlobalContext);
  const { socketResponse, socketConnect, socketIsConnected, socketEmit } = useSocketio();
  const [modalLoading, setModalLoading] = useState('none');
  const [modalTroco, setModalTroco] = useState('none');
  const [modalQrCode, setModalQrCode] = useState(false);
  const navigate = useNavigate();
  const [modalFinalizacao, setModalFinalizacao] = useState('none');
  const [modalLogin, setModalLogin] = useState('none');
  const [modalPergunta, setModalPergunta] = useState(false);

  const showHideModalFinalizacao = () => {
    setModalFinalizacao(modalFinalizacao == 'none' ? 'block' : 'none');
  };

  const showHideModalLogin = () => {
    setModalLogin(modalLogin == 'none' ? 'block' : 'none');
  };

  const showHideModalAutenticacao = useCallback(async () => {
    const aberta = await GetStatusLoja(dadosApp, statusLoja, setStatusLoja);
    if (!aberta && dadosApp?.Empresa?.Config?.agendamento === 0) {
      toast.error('Loja Fechada', {
        containerId: 'modalToast',
      });
      return;
    }
    setModalTroco(modalTroco == 'none' ? 'block' : 'none');
  }, [modalTroco, dadosApp, statusLoja, setStatusLoja]);

  const handleSetModalQrCode = useCallback(async () => {
    const aberta = await GetStatusLoja(dadosApp, statusLoja, setStatusLoja);
    if (!aberta && dadosApp?.Empresa?.Config?.agendamento === 0) {
      toast.error('Loja Fechada', {
        containerId: 'modalToast',
      });
      return;
    }

    if (dadosApp.Empresa.Config.mesa_cartao_hibrido) {
      setModalPergunta(true);
      return;
    }

    setModalQrCode(true);
  }, [dadosApp, statusLoja, setStatusLoja]);

  const handleEnviarPedido = async (e, isQRCode = false, QRCodeValue = 0) => {
    if (e) e.preventDefault();

    const listaPedidos = await GetListPedidosEnvio(dadosApp.IdLoja);
    if (listaPedidos.length === 0) {
      toast.error('Não foi possível selecionar os itens do pedido');
      return false;
    }

    // CONTINUAR DA CONFERENCIA
    // TRADUZIR A MENSAGEM DA PERMISSÃO
    // E CASO O USUÁRIO TENHA RECUSADO A PERMISSÃO
    // PEDIR MANUALMENTE ATRAVÉS DE CÓDIGO

    showHideModalLoading();
    // atualiza o número da mesa, caso o cliente iniciou o pedido em uma mesa e mudou
    listaPedidos.map((item) => {
      if (isQRCode) {
        item.numero_mesa = dadosApp.Qs.mesa; // mesa vem da url
        item.mesa = QRCodeValue; // vem da leitura do QRCode
        item.modulo = 'Cartao';
      } else {
        item.mesa = dadosApp.Qs.mesa;
        item.posicao = dadosApp.Qs.posicao;
        item.local_pedido = dadosApp.Qs.SetorTrabalho;
        item.setor_impressao = dadosApp.Qs.SetorTrabalho;
      }
    });

    const listaMesasCartoes = [...new Set(listaPedidos.map((obj) => obj.mesa))];
    const _usuario = GetUsuario(dadosApp.IdLoja);
    const pedido = {
      acao: 'FINALIZA PEDIDO',
      listaPedidos: listaPedidos,
      listaCartoes: listaMesasCartoes,
      tipoApp: 'comanda',
      pagamento: [],
      identificacao: {
        cpf: '',
        identificacao: '',
        nome_completo: _usuario?.nome_completo,
        telefone_ddd: _usuario?.telefone_ddd,
        telefone: _usuario?.telefone,
      },
      imprimirProducao: false,
      GUID: dadosApp.GuidSessao,
      cpfCnpj: '',
      geolocation: user.geolocation,
      portaria: false, //dadosApp.portaria, // removido por causa do QRCode
    };
    let _qs = { ...dadosApp.Qs };
    _qs.Solicitacao = '1'; // FINALIZA O PEDIDO
    _qs.Body = JSON.stringify(pedido);

    if (socketIsConnected()) socketEmit(_qs);
    else socketConnect(_qs);
  };

  const handleQrCode = (e) => {
    if (isNaN(e)) {
      toast.error('QRCode Inválido, verifique!');
      return;
    }
    handleEnviarPedido(null, true, e);
  };

  const handleOnClick = async (e) => {
    e.preventDefault();

    const aberta = await GetStatusLoja(dadosApp, statusLoja, setStatusLoja);
    //const isAutoAtendimento = dadosApp.Empresa?.Empresa?.tipo_app !== 'DELIVERY';

    if (!aberta && dadosApp?.Empresa?.Config?.agendamento === 0) {
      toast.error('Loja Fechada', {
        containerId: 'modalToast',
      });
      return;
    }

    if (user.id <= 0 && !dadosApp.aceitaPagamentoSemUsuario) {
      showHideModalLogin();
      return;
    }

    // valida o valor minimo quando for delivery ou auto atendimento balcao
    if (dadosApp.TipoApp === 'DELIVERY' || dadosApp.TipoApp === 'BALCAO') {
      if (sacola.ValorTotal < dadosApp.Empresa.Config.valor_minimo) {
        toast.error(`O valor mínimo do pedido ${FormataValor(dadosApp.Empresa.Config.valor_minimo)} não foi atingido`, {
          containerId: 'modalToast',
        });
        return;
      }
    }
    showHideModalFinalizacao();
  };

  const showHideModalLoading = useCallback(() => {
    setModalLoading(modalLoading == 'none' ? 'block' : 'none');
  }, [modalLoading]);

  const handleConfirmacaoTemComanda = (possuiComanda) => {
    setModalPergunta(false);

    if (!possuiComanda) {
      handleEnviarPedido(null, true, dadosApp.Qs.mesa);
    } else {
      setModalQrCode(true);
    }
  };

  const handleResposta = useCallback(
    (data) => {
      if (data) {
        switch (data.Solicitacao) {
          case '0': // STATUS_MESA - GETDADOS
          case '2': // CONFERENCIA
          case '3': // PAGAMENTO
          case '5': // PAGAMENTO
          case '8': // VALIDA PRODUTOS BALCAO
            //case '4': // STATUS_AUTO_ATENDIMENTO
            break;

          case '1': // FINALIZAR_PEDIDO
            if (data.readed) return;
            if (data.Status === 0) {
              ClearPedido(dadosApp.IdLoja, setSacola);
              navigate('/loja/PageSuccess?msg=Seu Pedido da Mesa ' + dadosApp.Mesa + ' foi Enviado com Sucesso!', {
                replace: true,
              });
            } else {
              try {
                const dados = JSON.parse(data.Body);
                navigate('/loja/Page404?message=' + dados.msg, { replace: true });
              } catch (error) {
                navigate('/loja/Page404?message=' + data.Body, { replace: true });
              }
            }
            break;

          default:
            navigate('/loja/Page404?message=Solicitação Não Homologada', { replace: true });
            break;
        }

        // if (data.Solicitacao !== '1') {
        //   if (data.Solicitacao !== '0') {
        //     if (data.Solicitacao !== '2') {
        //       if (data.Solicitacao !== '3') {
        //         if (data.Solicitacao === '4') {
        //
        //         } else {
        //           history.push('/loja/Page404?message=Solicitação Não Homologada');
        //         }
        //       }
        //     }
        //   }
        //
        //   return;
        // }

        // if (data.readed) return;
        // if (data.Status === 0) {
        //   ClearPedido(dadosApp.IdLoja, setSacola);
        //   history.replace('/loja/PageSuccess?msg=Seu Pedido da Mesa ' + dadosApp.Mesa + ' foi Enviado com Sucesso!');
        // } else {
        //   try {
        //     const dados = JSON.parse(data.Body);
        //     history.replace('/loja/Page404?message=' + dados.msg);
        //   } catch (error) {
        //     history.replace('/loja/Page404?message=' + data.Body);
        //   }
        // }
      } else {
        navigate('/loja/Page404?message=Erro ao obter resposta', { replace: true });
      }
      data.readed = true;
    },
    [navigate, dadosApp, setSacola],
  );

  // OBSERVA AS RESPOSTA DAS REQUISIÇÕES
  useEffect(() => {
    if (!isObjectEmpty(socketResponse)) {
      handleResposta(socketResponse);
    }
    return () => socketResponse;
  }, [socketResponse, handleResposta]);

  return (
    // <div className={`${param.origin == 'modal' ? 'footer-sticky' : 'btn_1_mobile'}`}>
    <div className={`${param.origin == 'modal' ? 'footer-sticky' : ''}`}>
      {dadosApp.TipoApp === 'DELIVERY' && (
        <Button
          onClick={handleOnClick}
          // eslint-disable-next-line prettier/prettier
          className={`btn_1 btnGradientInverted full-width mb_5 ${param.origin == 'modal' ? '' : 'sacola-footer'} ${!statusLoja.StatusLoja && dadosApp.Empresa.Config.agendamento === 0 ? 'btnDisabled' : ''
            // eslint-disable-next-line prettier/prettier
            }`}
          text={
            !statusLoja.StatusLoja && dadosApp.Empresa.Config.agendamento === 1
              ? 'Agendar Pedido'
              : !statusLoja.StatusLoja && dadosApp.Empresa.Config.agendamento === 1 // eslint-disable-next-line prettier/prettier
                ? 'Loja Fechada' // eslint-disable-next-line prettier/prettier
                : 'Finalizar Pedido'
          }
        />
      )}
      {dadosApp.TipoApp === 'BALCAO' && (
        <Button
          onClick={handleOnClick}
          // eslint-disable-next-line prettier/prettier
          className={`btn_1 btnGradientInverted full-width mb_5 ${param.origin == 'modal' ? '' : 'sacola-footer'} ${!statusLoja.StatusLoja ? 'btnDisabled' : ''
            // eslint-disable-next-line prettier/prettier
            }`}
          text={!statusLoja.StatusLoja ? 'Loja Fechada' : 'Finalizar Pedido'}
        />
      )}
      {dadosApp.TipoApp === 'MESA' && !dadosApp.portaria && (
        <Button
          onClick={showHideModalAutenticacao}
          // eslint-disable-next-line prettier/prettier
          className={`btn_1 btnGradientInverted full-width mb_5 ${param.origin == 'modal' ? '' : 'sacola-footer'} ${!statusLoja.StatusLoja ? 'btnDisabled' : ''
            // eslint-disable-next-line prettier/prettier
            }`}
          text={!statusLoja.StatusLoja ? 'Loja Fechada' : 'Enviar Pedido'}
        />
      )}
      {dadosApp.TipoApp === 'MESA' && dadosApp.portaria && (
        <Button
          //onClick={() => setModalQrCode(true)}
          onClick={handleSetModalQrCode}
          // eslint-disable-next-line prettier/prettier
          className={`btn_1 btnGradientInverted full-width mb_5 ${param.origin == 'modal' ? '' : 'sacola-footer'} ${!statusLoja.StatusLoja ? 'btnDisabled' : ''
            // eslint-disable-next-line prettier/prettier
            }`}
          text={!statusLoja.StatusLoja ? 'Loja Fechada' : 'Enviar Pedido'}
        />
      )}

      {modalPergunta && (
        <Modal
          title={'Você possui comanda?'}
          isFooter={false}
          visibility={modalPergunta ? 'block' : 'none'}
          page="CONFIRMACAO"
          param={{
            onClick: handleConfirmacaoTemComanda,
          }}
          btnOnClickClose={() => setModalPergunta(false)}
          customPosition="modal-position-bottom"
        />
      )}

      {modalFinalizacao === 'block' && (
        <Modal
          title="Finalize seu Pedido"
          isFooter={false}
          visibility={modalFinalizacao}
          page="FINALIZACAO"
          param={{ closeModal: param.closeModal }}
          btnOnClickClose={showHideModalFinalizacao}
        />
      )}
      {modalLogin === 'block' && (
        <Modal
          title="Login"
          isFooter={true}
          visibility={modalLogin}
          page="LOGIN"
          btnOnClickClose={showHideModalLogin}
        />
      )}
      {modalLoading === 'block' && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalLoading}
          param={{ msg: 'Aguarde...' }}
          page="LOADING"
          customPosition="loading-modal"
        />
      )}
      {modalTroco === 'block' && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalTroco}
          param={{
            code: dadosApp.Empresa.Config.senha,
            onClick: handleEnviarPedido,
            showHideModal: showHideModalAutenticacao,
            title: 'Autenticação',
          }}
          page="AUTENTICACAO"
          btnOnClickClose={showHideModalAutenticacao}
          customPosition="modal-position-bottom"
        />
      )}
      {modalQrCode && (
        <Modal
          title="Escaneie sua Comanda"
          isFooter={false}
          visibility={modalQrCode}
          param={{
            onClick: handleQrCode,
            showHideModal: () => setModalQrCode(false),
            title: 'Escaneie sua Comanda',
          }}
          page="QR_CODE"
          btnOnClickClose={() => setModalQrCode(false)}
          customPosition="modal-position-bottom"
        />
      )}
    </div>
  );
};

SacolaRodape.propTypes = {
  param: P.object,
};
